import { gql } from '@apollo/client'
import { WHOLE_DISPLAY_FRAGMENT } from '../fragments/WholeDisplayFragment'

export const UPDATE_DISPLAY = gql`
  mutation UpdateDisplay($input: UpdateDisplayInput!) {
    updateDisplay(input: $input) {
      display {
        ...WholeDisplay
      }
    }
  }
  ${WHOLE_DISPLAY_FRAGMENT}
`
